import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_apolloMutation__oj308g($this, mutation, $completion) {
  var tmp = $this.u6q().e65(mutation);
  var tmp_0 = $this.v6q($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp.x42('Authorization', 'Bearer ' + tmp_0).a5z($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function *_generator_apolloQuery__f2xn8l($this, query, $completion) {
  var tmp = $this.u6q().d65(query);
  var tmp_0 = $this.v6q($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp.x42('Authorization', 'Bearer ' + tmp_0).a5z($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function apolloMutation(mutation, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_apolloMutation__oj308g.bind(VOID, this, mutation), $completion);
}
function apolloQuery(query, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_apolloQuery__f2xn8l.bind(VOID, this, query), $completion);
}
var KtorQueryPerformerClass;
function KtorQueryPerformer() {
  if (KtorQueryPerformerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'KtorQueryPerformer', VOID, VOID, VOID, [1, 0]);
    KtorQueryPerformerClass = $;
  }
  return KtorQueryPerformerClass;
}
//region block: exports
export {
  KtorQueryPerformer as KtorQueryPerformer3enpohylr2sy5,
  apolloMutation as apolloMutation1qfm4b9xbpwrf,
  apolloQuery as apolloQuery2zskz0jq3m0l7,
};
//endregion

//# sourceMappingURL=KtorQueryPerformer.mjs.map
